<template>
  <div>

    <div class="reference-card-container">
      <table class="table">
        <tr class="header-row">
          <th colspan="3" scope="col">hotel size</th>
          <th colspan="1" rowspan="2" scope="col" class="column-stock-price">stock price</th>
          <th colspan="2" scope="col" class="column-bonus">majority stock holders bonus</th>
        </tr>

        <tr>
          <th scope="col">
            <div class="hotel-minor">
              <stock-card v-if="isVisible(HOTEL_LUXOR)" :hotel-id="HOTEL_LUXOR" compact />
              <stock-card v-if="isVisible(HOTEL_TOWER)" :hotel-id="HOTEL_TOWER" compact />
            </div>
          </th>

          <th scope="col">
            <div class="hotel-medium">
              <stock-card v-if="isVisible(HOTEL_AMERICAN)" :hotel-id="HOTEL_AMERICAN" compact />
              <stock-card v-if="isVisible(HOTEL_FESTIVAL)" :hotel-id="HOTEL_FESTIVAL" compact />
              <stock-card v-if="isVisible(HOTEL_WORLDWIDE)" :hotel-id="HOTEL_WORLDWIDE" compact />
            </div>
          </th>

          <th scope="col">
            <div class="hotel-major">
              <stock-card v-if="isVisible(HOTEL_CONTINENTAL)" :hotel-id="HOTEL_CONTINENTAL" compact />
              <stock-card v-if="isVisible(HOTEL_IMPERIAL)" :hotel-id="HOTEL_IMPERIAL" compact />
            </div>
          </th>

          <th colspan="1" scope="col">1st</th>
          <th colspan="1" scope="col">2nd</th>
        </tr>

        <tbody>
        <bonus-reference-card-row
          v-for="(row, index) in numberOfRows"
          :key="index"
          :row="index"
          :hotel-counts="hotelCounts"
        />
        </tbody>

      </table>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapGetters } from 'vuex';
import StockCard from "@/components/StockCard";
import {HOTEL_SIZE_RANGES} from "@/store/utils";
import {
  HOTEL_AMERICAN,
  HOTEL_CONTINENTAL,
  HOTEL_FESTIVAL,
  HOTEL_IMPERIAL,
  HOTEL_LUXOR,
  HOTEL_TOWER,
  HOTEL_WORLDWIDE, HOTELS,
} from "@/store/game/constants";
import BonusReferenceCardRow from "@/components/board/BonusReferenceCardRow";
import {NS_GAME_STATE} from "@/store/constants";
export default {
  name: 'BonusReferenceCard',

  components: {
    BonusReferenceCardRow,
    StockCard
  },

  data() {
    return {
      HOTEL_AMERICAN,
      HOTEL_CONTINENTAL,
      HOTEL_FESTIVAL,
      HOTEL_IMPERIAL,
      HOTEL_LUXOR,
      HOTEL_TOWER,
      HOTEL_WORLDWIDE,
      numberOfRows: HOTEL_SIZE_RANGES.length + 2 //2 is for the offset,
    }
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'tilesPerHotel'
    ]),

    hotelCounts() {
      const hotels = Object.entries(this.tilesPerHotel).map(([hotelId, tiles]) => {
        return {
          count: tiles.length,
          hotelId,
        }
      });

      return hotels.filter(hotel => {
        if (HOTELS.includes(hotel.hotelId)) {
          return true;
        }
        return false;
      });
    },
  },

  methods: {
    isVisible(hotelId) {
      return get(this, `tilesPerHotel[${hotelId}].length`, 0) <= 0;
    }
  }
}
</script>

<style scoped>
.reference-card-container {
  overflow-y: scroll;
  width: 100vw;
}

@media screen and (min-width: 587px) {
  .reference-card-container {
    overflow-y: initial;
    width: 100%;
  }
}

.hotel-minor,
.hotel-medium,
.hotel-major {
  display: flex;
  justify-content: center;
}

.hotel-minor {
  width: 83px;
}

.hotel-medium {
  width: 120px;
}

.hotel-major {
  width: 84px;
}

.table {
  width: 100%;
}

.header-row th {
  padding: 5px;
  font-weight: 600;
  line-height: 20px;
}

.column-stock-price {
  width: 65px;
}

.column-bonus {
  width: 150px;
}
/*.zebra tr:nth-child(odd) {*/
/*  background: #0000000d;*/
/*}*/
</style>
